SERVICES_URL = "http://services.skyframe.com";
UPLOADCARE_PUBLIC_KEY = "7d03b71f16da6316566c";
UPLOADCARE_IMAGE_SHRINK = '3300x5700'
UPLOADCARE_LOCALE_TRANSLATIONS = {
  errors: {
    'dimensions': 'The image you uploaded does not meet our minimum resolution.  We want your artwork to look amazing! Please upload an image 240 DPI or higher.'
  },
  dialog: {tabs: {preview: {error: {
    'dimensions': {
      title: 'Oops!',
      text: 'The image you uploaded does not meet our minimum resolution.  We want your artwork to look amazing! Please upload an image 240 DPI or higher.',
      back: 'Back'
    },
    'dpi': {
      title: 'Oops!',
      text: 'The image you uploaded does not meet our minimum resolution.  We want your artwork to look amazing! Please upload an image 240 DPI or higher.',
      back: 'Back'
    }
  }}}}
};
MAXFRAMESIZE = [34, 70];
BORDERSIZES = {
  'matting': [1, 1.25, 1.5, 1.75, 2, 2.5, 3, 3.5, 4, 4.5, 5],
  'print_border': [.25, .5, .75, 1, 1.5, 2]
};
FRAMEFILTERS = {
  price: [
    {min:0, max: 2, title: '$'},
    {min:2.01, max: 4, title: '$$'},
    {min:4.01, max: 6, title: '$$$'},
    {min:6.01, title: '$$$$'},
  ],
  width: [
    {min:0, max: .74, title: 'Less than 3/4"'},
    {min:.75, max: 1, title: '7/8" - 1"'},
    {min:1.01, title: '1" and above'}
  ],
  depth: [
    {min:0, max: 1, title: 'Up to 1"'},
    {min:1.01, max: 2.999, title: '1.01" - 3"'},
    {min:3, title: '3" and above'}
  ]
}
FRAMESUPPORT = [
  {matting: ["BOOK MAT", "BOOKMAT", "NO MAT", "MAT AND FLOAT"]},
  {matting: ["BOOK MAT", "MAT AND FLOAT", "MOUNTED/SHADOWBOX", "BOOKMAT", "FLOAT", "RAISED FLOAT", "NO MAT"]},
];

IMAGEDIMENSIONS = {
  '1:1': [
    { width: '8', height: '8' },
    { width: '10', height: '10' },
    { width: '12', height: '12' },
    { width: '16', height: '16' },
    { width: '20', height: '20' },
    { width: '24', height: '24' },
    { width: '30', height: '30' },
    { width: '40', height: '40' },
    { width: '45', height: '45' },
    { width: '50', height: '50' },
  ],
  '2:3': [
    { width: '8', height: '12' },
    { width: '10', height: '15' },
    { width: '12', height: '18' },
    { width: '14', height: '21' },
    { width: '18', height: '27' },
    { width: '20', height: '30' },
    { width: '24', height: '36' },
    { width: '28', height: '42' },
    { width: '30', height: '45' },
    { width: '34', height: '51' },
  ],
  '4:5': [
    { width: '8', height: '10' },
    { width: '12', height: '15' },
    { width: '16', height: '20' },
    { width: '20', height: '25' },
    { width: '24', height: '30' },
    { width: '28', height: '35' },
    { width: '32', height: '40' },
    { width: '36', height: '45' },
    { width: '30', height: '50' },
    { width: '34', height: '55' },
  ],
  '5:7': [
    { width: '10', height: '14' },
    { width: '15', height: '21' },
    { width: '20', height: '28' },
    { width: '25', height: '35' },
    { width: '30', height: '42' },
    { width: '35', height: '49' },
    { width: '40', height: '56' },
    { width: '45', height: '63' },
    { width: '50', height: '70' },
  ],
  '16:9': [
    { width: '32', height: '18' },
    { width: '48', height: '27' },
    { width: '64', height: '36', },
  ],
};
